import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface UseLossManagementProps {
  refetch: () => void;
}

export const useLossManagement = ({ refetch }: UseLossManagementProps) => {
  const [isLossDialogOpen, setIsLossDialogOpen] = useState(false);
  const [lossQuantity, setLossQuantity] = useState("");
  const [selectedItem, setSelectedItem] = useState<any>(null);

  const handleLossClick = (item: any) => {
    setSelectedItem(item);
    setIsLossDialogOpen(true);
  };

  const handleLossConfirm = async (quantity: number, selectedProductId: string) => {
    try {
      console.log("Current quantity:", selectedItem?.quantity);
      console.log("Adding quantity:", quantity);
      
      // Calculate new quantity
      const newQuantity = (selectedItem?.quantity || 0) + quantity;
      console.log("New quantity will be:", newQuantity);
      
      // Update the stock quantity
      const { error: updateError } = await supabase
        .from('stock_items')
        .update({ quantity: newQuantity })
        .eq('id', selectedProductId);

      if (updateError) {
        console.error("Update error:", updateError);
        toast.error("Erreur lors de la mise à jour du stock");
        return;
      }

      toast.success("Stock mis à jour avec succès");
      setIsLossDialogOpen(false);
      setLossQuantity("");
      setSelectedItem(null);
      
      // Force a refresh of the data
      await refetch();
    } catch (error: any) {
      console.error("Error details:", error);
      toast.error(error.message || "Erreur lors de la mise à jour du stock");
    }
  };

  return {
    isLossDialogOpen,
    setIsLossDialogOpen,
    lossQuantity,
    setLossQuantity,
    selectedItem,
    handleLossClick,
    handleLossConfirm
  };
};